import { db } from '../firebase';
import { 
  collection, 
  query, 
  where, 
  getDocs, 
  addDoc, 
  deleteDoc, 
  doc, 
  updateDoc,
  getDoc,
  setDoc
} from 'firebase/firestore';

export const initializeUserFinances = async (userId) => {
  const userDocRef = doc(db, 'users', userId);
  const userDoc = await getDoc(userDocRef);
  
  if (!userDoc.exists() || !userDoc.data().monthlyIncome) {
    await updateDoc(userDocRef, {
      monthlyIncome: 0
    });
  }

  const categoriesRef = collection(db, 'users', userId, 'categories');
  const categoriesSnapshot = await getDocs(categoriesRef);
  
  if (categoriesSnapshot.empty) {
    const defaultCategories = ['Food', 'Transport', 'Housing', 'Entertainment', 'Utilities', 'Other'];
    for (const category of defaultCategories) {
      await addDoc(categoriesRef, { name: category });
    }
  }
};

export const updateMonthlyIncome = async (userId, amount) => {
  const userDocRef = doc(db, 'users', userId);
  await updateDoc(userDocRef, {
    monthlyIncome: amount
  });
};

export const addCategory = async (userId, categoryName) => {
  const categoriesRef = collection(db, 'users', userId, 'categories');
  await addDoc(categoriesRef, { name: categoryName });
};

export const deleteCategory = async (userId, categoryName) => {
  // Delete category
  const categoriesRef = collection(db, 'users', userId, 'categories');
  const q = query(categoriesRef, where('name', '==', categoryName));
  const snapshot = await getDocs(q);
  snapshot.docs.forEach(async (doc) => {
    await deleteDoc(doc.ref);
  });

  // Delete associated transactions
  const transactionsRef = collection(db, 'users', userId, 'transactions');
  const transactionsQuery = query(transactionsRef, where('category', '==', categoryName));
  const transactionsSnapshot = await getDocs(transactionsQuery);
  transactionsSnapshot.docs.forEach(async (doc) => {
    await deleteDoc(doc.ref);
  });
};

export const addTransaction = async (userId, transactionData) => {
  const transactionsRef = collection(db, 'users', userId, 'transactions');
  await addDoc(transactionsRef, {
    ...transactionData,
    userId: userId
  });
};

export const deleteTransaction = async (userId, transactionId) => {
  await deleteDoc(doc(db, 'users', userId, 'transactions', transactionId));
}; 